import React from 'react';
import { Box, CardContent, Typography } from '@material-ui/core';
import clsx from 'clsx';
import PetCard from 'components/UI/PetCard';
import { Pet } from '@spike/pet-model';

interface PetsProps {
    pets: Pet[];
    classes: { [key: string]: string };
}

const Pets: React.FC<PetsProps> = ({ pets, classes }) => (
    <Box className={classes.cardStyle}>
        <CardContent className={classes.cardContent}>
            <Typography
                variant="h6"
                className={clsx(classes.cardTitle, classes.cardTitlePets)}
            >
                Pets
            </Typography>
            <Typography
                variant="body2"
                className={classes.cardSubtitle}
            >
                Pets Included in this membership.
            </Typography>
            <Box>
                {pets.map((pet, idx) => (
                    <PetCard
                        className={classes.petCard}
                        imageClassName={classes.petCardImage}
                        petSizeClassName={classes.petSizeContainer}
                        petItemLabelClassName={classes.petItemLabel}
                        pet={pet}
                        key={idx}
                    />
                ))}
            </Box>
        </CardContent>
    </Box>
);

export default Pets;
